export default {
  STEP_PAYMENT_OVERDUE: {
    TITLE:'Payment overdue',
    SUBTITLE:'We have failed to take payment from your card ending in {{{last4}}}.',
    DESCRIPTION: 'We will try to process your payment again in {{{xDays}}}, please review your payment method before then. If unsuccessful, your account will be downgraded on {{{downgradeDate}}}.',
    BUTTON_CONFIRM: 'Confirm',
  }, 
} 